import React, { useState } from 'react';



import {
  ChevronLeft,
  ChevronRight
} from 'react-feather';

const SliderFiles = ({ files }) => {

  const [count, setCount] = useState(0);

  const handleNext = () => {
    count >= files.length - 1 ? setCount(0) : setCount(count + 1);
  }

  const handlePrev = () => {
    count <= 0 ? setCount(files.length - 1) : setCount(count - 1);
  }

  return (
    <div className="pics-slider">
      <div>

        <div className="pics-btns">
          <button className="action-btn" onClick={handlePrev}>
            <ChevronLeft size={24} />
          </button>

          <div className="pics">
            {files[count].type.includes("image") && (
                <img src={files[count].path} />
            )}
            {files[count].type.includes("application") && (
                <img src={require(`../imgs/fiile.jpg`)} />
            )}
            {files[count].type.includes("video") && (
                <img src={require(`../imgs/video.jpg`)} />
            )}
            {files[count].type.includes("audio") && (
                <img src={require(`../imgs/audio.jpg`)} />
            )}
          </div>

          <button className="action-btn" onClick={handleNext}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="dots">
          {files.map((_, index) => {
            return (
              <div className="dot"></div>
            )
          })}
        </div>
        <div className="name">
            <span>{files[count].name.substring(0,40)}</span>
        </div>
      </div>
    </div>
  );
}

export default SliderFiles;